// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2je9o","emails":"CreateEditClinics_emails__10TBs","emailTagLabel":"CreateEditClinics_emailTagLabel__2zcu6"};